module.exports = __webpack_public_path__ + "static/media/qr_code_slider_phone3.e2b99282.png";